// import React from "react";
import { Route, Routes } from "react-router-dom";
import HealthOneHome from "../healthOnePages/healthOneHome/HealthOneHome";
import Navbar from "../../../../../src/default-components/Navbar";
import "../healthOneCss/HealthOneStyle.scss";
import BusinessThreeNavbar from "../../../business/businessThree/businessThreeComponents/BusinessThreeNavbar";
import GlobalRoute from "../../../../global route/GlobalRoute";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import PGBusinessThreeAboutUs from "../../../business/businessThree/businessThreePages/PGBusinessThreeAboutUs";
const HealthOneRoute = () => {
  const { document: navTypeDoc } = useDocument("settings", "navbarType");

  return (
    <div className="health_one_route_parent_div">
      {navTypeDoc && navTypeDoc.activeNav == "FixNav" ? (
        <Navbar />
      ) : (
        <BusinessThreeNavbar />
      )}
      <Routes>
        <Route path="/" element={<HealthOneHome />}></Route>
        <Route path="/aboutus" element={<PGBusinessThreeAboutUs />} />
      </Routes>
      <GlobalRoute />
    </div>
  );
};

export default HealthOneRoute;
